module.exports = __webpack_public_path__ + "static/logo-185b6f556d96dae64f457c5dc7862e58.png";